
import accidents from "./accidents";
import vehiclesManagement from './vehicles-management';
import { Repair } from "../CRUDs/entities/Repair";
export default {
    init() {
        accidents.sort_date('repair-list__table-box-img');
        this.listeners();
    },

    listeners(){
        $('body').off('click', '.data-view.repair-lists .data-row .edit')
                .on('click', '.data-view.repair-lists .data-row .edit', ev=>{
            new Repair($(ev.currentTarget).data('repair_id')).openModal('edit');
            vehiclesManagement.mytag('repairs_add', 1);
        })
    },

    sort_date(className = '') {
        if (className == '') return false;
        $('.' + className).click(function (e){
            let sortElem = $(this);
            if (sortElem.data('sort-direction') == 'desc') {
                sortElem.data('sort-direction', 'asc')
            }else{
                sortElem.data('sort-direction', 'desc')
            }
            if('URLSearchParams' in window && sortElem){
                let searchParams = new URLSearchParams(window.location.search);
                searchParams.set('sort', sortElem.data('sort'));
                searchParams.set('sort_direction', sortElem.data('sort-direction'));
                window.location.search = searchParams.toString();
            }
        });
    },
}
